module.exports = __webpack_public_path__ + "static/sobotka-5a57ae365d47a3628b01ec9bc38d535e.jpg";